module.exports = __webpack_public_path__ + "img/caret-right.da1d93bf.svg";